/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".inline[_ngcontent-%COMP%]{display:flex}.dynamic[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap}.dynamic[_ngcontent-%COMP%]   .custom-control[_ngcontent-%COMP%]{flex-basis:20%}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/access-management/radio-select/radio-select.component.scss.shim.ngstyle.js.pre-build-optimizer.js